import { Navigate, type RouteObject } from 'react-router';
import { page } from '@/lib/lazy-route';

// Payroll (Phase H). Owned by the payroll module; other Phase H tracks add their pages to the
// children below and a tab to payroll-layout.tsx.
export const routes: RouteObject[] = [
  {
    path: 'payroll',
    lazy: page(() => import('./payroll-layout'), (m) => m.PayrollLayout),
    children: [
      { index: true, element: <Navigate to="runs" replace /> },
      // H-F pay runs
      { path: 'runs', lazy: page(() => import('./payrun/runs-page'), (m) => m.PayRunsPage) },
      { path: 'runs/:id', lazy: page(() => import('./payrun/run-detail-page'), (m) => m.PayRunDetailPage) },
      { path: 'leavers', lazy: page(() => import('./payrun/leavers-page'), (m) => m.LeaversPage) },
      { path: 'corrections', lazy: page(() => import('./payrun/corrections-page'), (m) => m.CorrectionsPage) },
      // H-B records
      { path: 'employees', lazy: page(() => import('./employees-page'), (m) => m.PayrollEmployeesPage) },
      { path: 'inputs', lazy: page(() => import('./inputs-page'), (m) => m.PayInputsPage) },
      { path: 'schedules', lazy: page(() => import('./schedules-page'), (m) => m.PaySchedulesPage) },
      { path: 'schemes', lazy: page(() => import('./employers-page'), (m) => m.PayeSchemesPage) },
      { path: 'elements', lazy: page(() => import('./elements-page'), (m) => m.PayElementsPage) },
      { path: 'legal-holds', lazy: page(() => import('./legal-holds-page'), (m) => m.LegalHoldsPage) },
      // H-G outputs
      { path: 'outputs', lazy: page(() => import('./outputs/runs-page'), (m) => m.PayRunsPage) },
      { path: 'outputs/:id', lazy: page(() => import('./outputs/run-page'), (m) => m.PayRunPage) },
      { path: 'year-end', lazy: page(() => import('./outputs/year-end-page'), (m) => m.YearEndPage) },
      { path: 'payment-settings', lazy: page(() => import('./outputs/payment-settings-page'), (m) => m.PaymentSettingsPage) },
      // H-H benefits in kind
      { path: 'benefits', lazy: page(() => import('./benefits/benefits-page'), (m) => m.BenefitsInKindPage) },
    ],
  },
];

export const orgRoutes: RouteObject[] = [];
